import {useNavigate} from "react-router-dom";
import {sendRequestAuth} from 'api/api'
import useAlert from 'hook/useAlert'
import {  useContext } from 'react'
import {facebookMessageConfirmOrderActions as actions} from '../provider/_actions'
import {FacebookMessageConfirmOrderContext} from "../provider/_context";
import {
    confirmMessageGetDetail,
    confirmMessageStatus,
    confirmMessageUpdateDetail,
    getListFanPages
} from "../../../../../api/url";
import useGlobalContext from "../../../../../containerContext/storeContext";
import {getText, getTextCount, parseTextToSlate} from "../../../utils/getText";

const useFacebookMessageConfirmOrder = () => {
    const navigate = useNavigate()
    const {showAlert} = useAlert()
    const [GlobalState] = useGlobalContext()
    const {auth} = GlobalState.facebookAuth
    const {state, dispatch} = useContext(FacebookMessageConfirmOrderContext)
    const {confirmStatus} = state.modal
    // =======================================================================
    // TABLE
    // =======================================================================


    const fetchOrigin = async () =>{
        const response = await sendRequestAuth(
            'get',
            getListFanPages(auth.userId)
        )
        if (!!response?.data?.success) {

            dispatch({
                type: actions.MESSAGE_CONFIRM_LIST_UPDATE,
                payload: {list: response?.data?.data},
            })
        }
        setTimeout(
            () =>
                dispatch({
                    type: actions.MESSAGE_CONFIRM_LOADING_UPDATE,
                    payload: {loading: false},
                }),
            500,
        )
    }

    const handleStatus = async data =>{
        const query = {
            page_id: data?.page_id,
            status: +data?.confirm_message === 1 ? 0 : 1
        }
        if(+data?.confirm_message === 1)
            dispatch({
                type: actions.MESSAGE_CONFIRM_MODAL_STATUS,
                payload:{
                    data:data,
                    open: true
                }
            })
        else{
            const response = await sendRequestAuth('post', confirmMessageStatus(), query)
            if(!!response?.data?.success){
                fetchOrigin()
                showAlert({type:'success', content:response?.data?.message})
            }else{
                showAlert({type:'danger', content: response?.data?.message})
            }

        }

    }

    const handleCancelModal = _=>{
        dispatch({
            type: actions.MESSAGE_CONFIRM_MODAL_STATUS,
            payload:{
                data: confirmStatus?.data,
                open: false
            }
        })
    }
    const handleConfirmStatus = async _ =>{
        const query = {
            page_id: confirmStatus?.data?.page_id,
            status: 0
        }
        const response = await sendRequestAuth('post', confirmMessageStatus(), query)
        if(!!response?.data?.success){
            dispatch({
                type: actions.MESSAGE_CONFIRM_MODAL_STATUS,
                payload:{
                    data: null,
                    open: false
                }
            })
            fetchOrigin()
            showAlert({type:'success', content:response?.data?.message})
        }else{
            showAlert({type:'danger', content: response?.data?.message})
        }

    }
    const getDetailPage= async (pageId)=>{
        const response= await sendRequestAuth('get',confirmMessageGetDetail(pageId))
        if(!!response?.data?.success){
            dispatch({
                type: actions.MESSAGE_CONFIRM_GET_DETAIL,
                payload:{
                    content_message: !!response?.data?.data?.content_message ?
                        parseTextToSlate(JSON.parse(response?.data?.data?.content_message))
                        : detail.samples,
                    status: +response?.data?.data.confirm_message
                }
            })
        }
    }
    const {detail}= state
    const handleResetContent=()=>{
        dispatch({
            type: actions.MESSAGE_CONFIRM_RESET_CONTENT,
            payload: true
        })
    }
    const handleChangeMessage = (val) =>{
        dispatch({type:actions.MESSAGE_CONFIRM_CHANGE_MESSAGE, payload: val})
    }
    const handleChangeStatus = (val) =>{
        dispatch({type:actions.MESSAGE_CONFIRM_CHANGE_STATUS, payload: !!val ? 1 : 0})
    }

    const handleBlurMessage = _ =>{
        const text = getTextCount(detail.content_message)
        let content = ''
        if(text.length === 0) content ='validate_message_confirm_blank'
        if(text.length > 300) content ='validate_message_confirm_not_over_300'
        dispatch({type: actions.VALIDATE_MESSAGE_CONFIRM, payload: content})
    }
    const handleSubmit= async (pageId)=>{
        const data={
            "page_id" : pageId,
            "content_message" : getText(detail.content_message),
            "confirm_message": detail.status
        }
        const countText= getTextCount(detail.content_message)
        if(countText.length === 0 || countText.length > 300)
            return
        const response = await sendRequestAuth('post',confirmMessageUpdateDetail(), data)
        if(!!response.data?.success){
            navigate('/facebook/message-confirm-order')
            showAlert({type:'success', content:response?.data?.message})
        }else{
            showAlert({type:'danger', content: response?.data?.message})
        }
    }
    return {
        data: state,
        methods: {
            fetchOrigin,
            // table
            onChangeStatus: handleStatus,
            onCancel: handleCancelModal,
            onConfirm: handleConfirmStatus,
            fetchDetail: getDetailPage,
            onReset:handleResetContent,
            onChangeMessage: handleChangeMessage,
            onChangeMessageStatus: handleChangeStatus,
            onBlurMessage: handleBlurMessage,
            onSubmit: handleSubmit
        },
    }
}

export default useFacebookMessageConfirmOrder
